var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length > 0)?_c('vs-alert',{staticClass:"my-3",staticStyle:{"height":"auto !important"},attrs:{"color":"danger","title":"Atenção!!","active":"true"}},[_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,staticClass:"mb-2"},[_vm._v("\n      "+_vm._s(error)+"\n    ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }